@if (hasFileDownload) {
  <button
    (click)="onShowImageDialog($event)"
    [ngClass]="[hasBrowserManifest ? 'plausible-event-name=Catalog+Open+Browser' : '']"
    [title]="title | transloco"
    mat-icon-button
    >
    <mat-icon [ngClass]="iconClass">{{ icon }}</mat-icon>
  </button>
}
